import { render, staticRenderFns } from "./coach-enrolments-modal.vue?vue&type=template&id=87725fbc"
import script from "./coach-enrolments-modal.vue?vue&type=script&lang=js"
export * from "./coach-enrolments-modal.vue?vue&type=script&lang=js"
import style0 from "./coach-enrolments-modal.vue?vue&type=style&index=0&id=87725fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports